import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { usePermissions } from '@/features/auth';

type Props = {
  permission?: string;
  children: ReactNode;
};

export function RequirePermission({ permission, children }: Props) {
  const { can } = usePermissions();

  if (permission !== undefined && !can(permission)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
